import { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import FormDatePicker from '../../components/forms/formDatePicker';
import FormInput from '../../components/forms/formInput';
import OverlayLoader from '../../components/overlayLoader';
// import ExpenseTypesSelect from '../../components/selects/expenseTypesSelect';
import { createExpense, getById, updateExpense } from '../../services/expenses';
import { isAdmin, toLocalDateString, trimProps } from '../../utils/helper';
import { onMutateSuccess, onQuerySuccess } from '../../utils/queryResponse';
import SbrDrawer from '../../components/sbr/SbrDrawer';
// import SetExpenseTypeModal from '../expenseTypes/expenseTypeSet';

const ReceiptIcon = () => (
    <svg className="ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 21V5a2 2 0 0 1 2-2h7l5 5v13l-2-1.2-2 1.2-2-1.2L11 21l-2-1.2L7 21l-2-1.2Z" /><path d="M9 7h4M9 11h6M9 15h6" /></svg>
);

const initExpense = {
    category: '',
    description: '',
    amount: '',
    date: new Date(),
    paymentMethod: ''
}

const SetExpenseModal = ({
    display,
    toggle,
    expenseId,
    onClose,
}) => {

    const { t } = useTranslation();
    const [expense, setExpense] = useState(initExpense)
    // const [expenseTypeModal, setExpenseTypeModal] = useState(false)

    const queryClient = useQueryClient()

    const { mutate, isLoading } = useMutation( expenseId ? updateExpense : createExpense, {
        onSuccess: onMutateSuccess(() => {
            queryClient.invalidateQueries(['expenses', 'paginated'])
            // queryClient.invalidateQueries('cash-flow')
            expenseId && queryClient.invalidateQueries(['expenses','details', expenseId])
            onHide()
        })
    })

    const { data, isFetching } = useQuery(['expenses','details', expenseId], () => expenseId && getById(expenseId), {
        staleTime: 1000 * 60 * 2,
    })

    useEffect(() => {
        onQuerySuccess(data, (result) => {
            // const _expense = trimProps(result, initExpense, [])
            // _expense.date = toLocalDateString(_expense.date)
            setExpense(result)
        })
    }, [data])

    const onShow = () => {
        !expenseId && setExpense(initExpense)
    }

    const onHide = () => {
        toggle(false)
        onClose()
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        e.stopPropagation()

        mutate(expense)
    }

    const handleChange = (objValue) => {
        const newExpense = { ...expense, ...objValue }
        setExpense(newExpense)
    }

    // const handleIsRecurringChange = (e) => {
    //     const isRecurring = e.target.checked
    //     if(isRecurring) {
    //         handleChange({ isRecurring })
    //     } else {
    //         handleChange({ isRecurring , recurringPeriod: '' })
    //     }
    // }

    return (
        <>
            {/* <SetExpenseTypeModal display={expenseTypeModal} toggle={setExpenseTypeModal} /> */}

            <SbrDrawer
                show={display}
                onHide={onHide}
                onShow={onShow}
                backdrop={isLoading ? 'static' : true}
                title={expenseId ? t('expenses.editExpense') : t('expenses.addExpense')}
                subtitle={expenseId ? t('expenses.updateRecord') : t('expenses.recordNew')}
                icon={<ReceiptIcon />}
                footer={
                    <>
                        <button type="button" className="btn-sbr btn-ghost-sbr btn-sm-sbr" onClick={onHide} disabled={isLoading}>{t('common.cancel')}</button>
                        <button type='submit' form="set-expense" className="btn-sbr btn-primary-sbr btn-sm-sbr" disabled={isLoading}>
                            {isLoading ? t('expenses.submitting') : (expenseId ? t('expenses.saveExpense') : t('expenses.addExpense'))}
                        </button>
                    </>
                }
            >
                <Form id='set-expense' onSubmit={handleSubmit} style={{ position: 'relative' }}>
                    <Row className="mb-3">
                        {/* <Col lg="12" className='d-flex'>
                                <div className='flex-fill'>
                                <ExpenseTypesSelect className="mb-2" label="Type" value={expense.type ?? ''}
                                    onChange={(option) => handleChange({ type: option.value })}
                                    placeholder='Select Type'
                                    required
                                />
                                </div>
                                {isAdmin() &&
                                    <Form.Group>
                                        <Form.Label>&nbsp;</Form.Label>
                                        <div className='px-2 py-1'>
                                            <i className="fa-solid fa-square-plus action"
                                                title='Add Expense Type'
                                                onClick={() => setExpenseTypeModal(true)}
                                                style={{ fontSize: '2em' }}>
                                            </i>
                                        </div>
                                    </Form.Group>
                                }
                            </Col> */}
                        <Col lg="6">
                            <FormInput className="mb-2" label={t('expenses.amount')} value={expense.amount ?? ''}
                                onChange={(e) => handleChange({ amount: e.target.value })}
                                type='number' min='1' step='0.01' placeholder={t('expenses.enterAmount')}
                                required
                            />
                        </Col>
                        <Col lg="6">
                            <FormDatePicker className="form-control mb-2" label={t('expenses.date')} selected={expense.date ? new Date(expense.date) : null}
                                onChange={(date) => handleChange({ date })}
                                required
                            />
                        </Col>
                        <Col lg="6">
                            <FormInput className="mb-2" label={t('expenses.paymentMethod')} value={expense.paymentMethod ?? ''}
                                onChange={(e) => handleChange({ paymentMethod: e.target.value })}
                                placeholder={t('expenses.enterPaymentMethod')}
                                required
                            />
                        </Col>
                        <Col lg="6">
                            <FormInput className="mb-2" label={t('common.category')} value={expense.category ?? ''}
                                onChange={(e) => handleChange({ category: e.target.value })}
                                placeholder={t('expenses.enterCategory')}
                                required
                            />
                        </Col>
                        {/* <Col lg="12" className='mt-2'>
                                <Form.Group>
                                    <Form.Check label="Is Recurring" value={expense.isRecurring} checked={expense.isRecurring} onChange={handleIsRecurringChange} />
                                </Form.Group>
                            </Col>
                            { expense.isRecurring &&
                            <Col lg="12">
                                <FormInput className="mb-2" label="Recurring Period" value={expense.recurringPeriod ?? ''}
                                    onChange={(e) => handleChange({ recurringPeriod: e.target.value })}
                                    placeholder='Enter Recurring Period'
                                    required
                                />
                            </Col>
                            } */}
                        <Col lg="12">
                            <FormInput className="form-control mb-2" label={t('expenses.description')} value={expense.description ?? ''}
                                onChange={(e) => handleChange({ description: e.target.value })}
                                as='textarea'
                            />
                        </Col>
                    </Row>

                    {isFetching &&
                        <OverlayLoader />
                    }

                </Form>
            </SbrDrawer>

        </>
    )
}

export default SetExpenseModal
